<template>
  <div class="services-filter filter-form">
    <b-form-group>
      <b-form-checkbox-group id="travelPolicy" :name="name" @input="emitChanges"
                             v-model="selected" :options="options" stacked
      />
    </b-form-group>

    <p class="text-right">
      <b-button class="btn-as-link" @click="reset">
        {{ $t('_reset') }}
      </b-button>
    </p>
  </div>
</template>

<script>
import filtersMixin from '@/components/frontoffice/Booking/filters/mixin'

export default {
  mixins: [filtersMixin],

  data () {
    return {
      selected: []
    }
  },

  methods: {
    emitChanges () {
      let ret = []

      for (let selected of this.selected) {
        ret.push(this.options.find(option => {
          return option.value === selected
        }))
      }

      this.$emit('update', {
        name: this.name,
        value: ret
      })
    },

    reset (propagate = true) {
      this.selected = []
      if (propagate) this.emitChanges()
    }
  }
}
</script>
